import { combineReducers } from 'redux';
import ambassador from 'products/global/views/Ambassador/state';
import nps from 'products/global/views/NPS/state';

// ================== Reducers ================== //

const globalReducer = combineReducers({
  ambassador,
  nps
});

export default globalReducer;
